<div id="autobiddingView_{{id}}" class="">
	<div id="autobidMessage_{{id}}" class="col-md-12 col-sm-12 col-xs-12 text-center"></div>
</div>
